import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI';
import { invoiceBillingStateClass } from './interfaces/invoiceBillingStateClass';
import moment from 'moment';
import { parseLocalizedNumber, parseCultureNumber, formatNumberCustomoriginalapiv2
    , determineCommaSeprater, parseByCulture, sortData } from '../../common/timeLiveFunction';
import { string } from 'yup';

const initialState: invoiceBillingStateClass = {
    isLoading: true,
    isListLoading: true,
    isReload: false,
    status: 'idle',
    timeExpenseInvoiceList: [],
    AccountTimeExpenseBillingIds:[],
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    sortOrder: 'asc',
    sortColumn: '1',
    isAllChecked:false,
    //pagination
    // timesheetBillingList: [{
    //     "AccountClientId": 0,
    //     "EmployeeName": "",
    //     "ProjectName": "",
    //     "TaskName": "",
    //     "AccountProjectTaskId": 0,
    //     "AccountProjectId": 0,
    //     "AccountTimeExpenseBillingTimesheetId": "",
    //     "Description": "",
    //     "BillingRate": 0.0,
    //     "BillHours": 0.0,
    //     "TotalAmount": 0.0,
    //     "AccountTaxCodeId1": null,
    //     "AccountTaxCodeId2": null,
    //     "TaxCode2": 0.0,
    //     "TaxCode1": 0.0,
    //     "ActualHours": 0.0,
    //     "ActualBillingRate": 0.0,
    //     "PartyName": "",
    //     "AccountTimeExpenseBillingId": "",
    //     "AccountEmployeeTimeEntryId": null,
    //     "ExchangeRate": null,
    //     "AccountEmployeeId": null,
    //     "TaxName1": null,
    //     "TaxName2": null,
    //     "IsSelected": true,
    //     "IsEditable": false,
    //     "ProjectTaskArray": []
    // }],
    timesheetBillingList: [],
    // expenseBillingList: [{
    //     "ProjectName": null,
    //     "AccountProjectId": null,
    //     "AccountClientId": 0,
    //     "AccountTimeExpenseBillingExpenseId": "",
    //     "AccountTimeExpenseBillingId": "",
    //     "Description": "",
    //     "ActualExpenseAmount": 0,
    //     "BilledExpenseAmount": 0,
    //     "AccountExpenseId": null,
    //     "AccountExpenseName": null,
    //     "AccountExpenseTypeId": null,
    //     "ExpenseType": null,
    //     "ExchangeRate": 1,
    //     "AccountTaxCodeId1": null,
    //     "AccountTaxCodeId2": null,
    //     "TaxCode1": 0,
    //     "TaxCode2": 0,
    //     "AccountExpenseEntryId": "0",
    //     "TaxName1": null,
    //     "TaxName2": null,
    //     "IsSelected": true,
    //     "IsEditable": false
    // }],
    expenseBillingList: [],
    accountTimeExpenseBillingId: '',
    currenciesList: [],
    accountClientId: 0,
    accountProjectId: 0,
    accountProjectTaskId: 0,
    accountTaxCodeList: [],
    accountExpenseNameList: [],
    accountExpenseTypeList: [],
    subTotal: 0,
    discount: 0,
    taxCode1: 0,
    taxCode2: 0,
    grandTotal: 0,
    dueDate: '',
    taxCodeFormula1: 0,
    taxCodeFormula2: 0,
    isCalculateByPercentage: true,
    masterAccountTimeExpenseBilling: [{
        "AccountClientContactId": 0,
        "AccountClientId": 0,
        "AccountCurrencyId": 0,
        "AccountProjectId": 0,
        "AccountTimeExpenseBillingId": "",
        "BankDetails": "",
        "Billable": -1,
        "BillingCycleEndDate": '',
        "BillingCycleStartDate": '',
        "Description": "",
        "Discount": 0,
        "DiscountPercentage": 0,
        "EmailTo": "",
        "GrandTotal": 0,
        "GroupExpenseBillingListBy": "",
        "GroupTimesheetBillingListBy": "",
        "InvoiceDate": "",
        "InvoiceDueDate": "",
        "InvoiceNo": 0,
        "InvoicePrefix": "",
        "IsBilled": false,
        "IsEmailSend": 0,
        "IsPaid": false,
        "PONumber": "",
        "ParentAccountProjectTaskId": 0,
        "ShowDiscountCalculationBy": 0,
        "SubTotal": 0,
        'TaxCode1': 0,
        "TaxCode2": 0,
        "Terms": "",
        "filterEmployees": "",
        "AccountTaxCodeId1": 0,
        "AccountTaxCodeId2": 0,
        "TaxName1": "",
        "TaxName2": ""
    }],
    discountPercentage: 0,
    projectTaskArray: [{ index: 0, taskArray: [] }],
    accountTimeExpenseBillingIdForPrint: '',
    clientInvoiceFooter: "",
    checkedRecordsForBilled: [],
    masterCurrencyCode:"",
    masterCurrencyExchangeRate:1
}

interface IThunkApi {
    state: {
        globalState: any;
        invoiceBilling: invoiceBillingStateClass;
    }
}

export const getTimeExpenseInvoiceList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Invoice/getTimeExpenseInvoiceList',
        async (arg, thunkApi) => {
            const { startRec, search, pageNo, pageSize, sortOrder, sortColumn } = thunkApi.getState().invoiceBilling;      
            const response = await fetchAPI(`api/V2/Invoice/TimeExpenseBillingDataTable/${startRec}/${pageSize}/${pageNo}/${sortOrder}/${sortColumn}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAllDataInSingleRequestForInvoiceForm = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Invoice/getAllDataInSingleRequestForInvoiceForm',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/Invoice/GetAllDataInSingleRequestForInvoiceForm`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getInvoiceMasterandDetailRecordsList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Invoice/getInvoiceMasterandDetailRecordsList',
        async (arg, thunkApi) => {
            const { accountTimeExpenseBillingId } = thunkApi.getState().invoiceBilling;
            const response = await fetchAPI(`api/V2/Invoice/InvoiceMasterandDetailRecordsForEdit/?AccountTimeExpenseBillingId=${accountTimeExpenseBillingId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getTimeExpenseBillingInvoice = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/getTimeExpenseBillingInvoice',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/Invoice/GetAccountTimeExpenseBillingInvoice/?Type=${arg.grouptype}&ExpenseInvoiceGroup=${arg.expenseInvoiceGroup}&AccountClientId=${arg.accountClientId}&BillingCycleStartDate=${arg.billingCycleStartDate}&BillingCycleEndDate=${arg.billingCycleEndDate}&AccountProjectId=${arg.accountProjectId}&AccountCurrencyId=${arg.accountCurrencyId}&Billable=${arg.billable}&ParentTaskId=${arg.accountProjectTaskId}&InvoiceRecordsFor=${arg.invoiceRecordsFor}&EmployeeValues=${arg.filterEmployees}&AccountTaxCodeId1=${arg.AccountTaxCodeId1}&AccountTaxCodeId2=${arg.AccountTaxCodeId2}`, 'Get', '', true);
            const json = await response.json();
            return { json, invoiceRecordsFor: arg.invoiceRecordsFor };
        }
    )

export const updateAccountInvoice = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Invoice/updateAccountInvoice',
        async (arg, thunkApi) => {
            const { dateInsertionFormat } = thunkApi.getState().globalState;
            const { timesheetBillingList, expenseBillingList, masterAccountTimeExpenseBilling } = thunkApi.getState().invoiceBilling;
            let AccountTimeExpenseBillingTimesheet: any[] = [];
            let AccountTimeExpenseBillingExpense: any[] = [];
            
            timesheetBillingList.length > 0 && timesheetBillingList.map((item) => {
                let timesheetObject = {
                    "AccountProjectId": 0,
                    "AccountProjectTaskId": 0,
                    "Description": " ",
                    "ActualBillingRate": 0,
                    "BillingRate": 0,
                    "ActualHours": 0,
                    "BillHours": 0,
                    "AccountTaxCodeId1": 0,
                    "AccountTaxCodeId2": 0,
                    "TaxCode1": 0,
                    "TaxCode2": 0,
                    "TotalAmount": 0,
                    "AccountEmployeeTimeEntryId": "0",
                    "AccountTimeExpenseBillingTimesheetId": "",
                    "AccountEmployeeId": 0
                }
                
                timesheetObject.AccountProjectId = item.AccountProjectId;
                timesheetObject.AccountProjectTaskId = item.AccountProjectTaskId;
                timesheetObject.Description = item.Description;
                timesheetObject.ActualBillingRate = item.ActualBillingRate;
                timesheetObject.BillingRate = parseLocalizedNumber(item.BillingRate) ?? 0;

                timesheetObject.ActualHours = item.ActualHours;
                timesheetObject.BillHours = parseLocalizedNumber(item.BillHours) ?? 0//Number(item.BillHours);
                timesheetObject.AccountTaxCodeId1 = item.AccountTaxCodeId1 === null ? timesheetObject.AccountTaxCodeId1 : item.AccountTaxCodeId1;
                timesheetObject.AccountTaxCodeId2 = item.AccountTaxCodeId2 === null ? timesheetObject.AccountTaxCodeId2 : item.AccountTaxCodeId2;
                timesheetObject.TaxCode1 = Number(item.TaxCode1);
                timesheetObject.TaxCode2 = item.TaxCode2;
                timesheetObject.TotalAmount = parseLocalizedNumber(item.TotalAmount) ?? 0//item.TotalAmount;
                timesheetObject.AccountEmployeeTimeEntryId = item.AccountEmployeeTimeEntryId === null ? timesheetObject.AccountEmployeeTimeEntryId : item.AccountEmployeeTimeEntryId;
                timesheetObject.AccountTimeExpenseBillingTimesheetId = item.AccountTimeExpenseBillingTimesheetId;
                timesheetObject.AccountEmployeeId = 0;
                AccountTimeExpenseBillingTimesheet.push(timesheetObject);
            })
                        //:
            // AccountTimeExpenseBillingTimesheet.push({
            //     "AccountProjectId": 0,
            //     "AccountProjectTaskId": 0,
            //     "Description": " ",
            //     "ActualBillingRate": 0,
            //     "BillingRate": 0,
            //     "ActualHours": 0,
            //     "BillHours": 0,
            //     "AccountTaxCodeId1": 0,
            //     "AccountTaxCodeId2": 0,
            //     "TaxCode1": 0,
            //     "TaxCode2": 0,
            //     "TotalAmount": 0,
            //     "AccountEmployeeTimeEntryId": "0",
            //     "AccountTimeExpenseBillingTimesheetId": "",
            //     "AccountEmployeeId": 0
            // });

            expenseBillingList.length > 0 && expenseBillingList.map((item: any) => {
                let expenseObject = {
                    "AccountProjectId": 0,
                    "AccountExpenseTypeId": 0,
                    "AccountExpenseId": 0,
                    "Description": "",
                    "ActualExpenseAmount": 0,
                    "BilledExpenseAmount": 0,
                    "AccountTaxCodeId1": 0,
                    "AccountTaxCodeId2": 0,
                    "TaxCode1": 0,
                    "TaxCode2": 0,
                    "AccountExpenseEntryId": "0",
                    "AccountTimeExpenseBillingExpenseId": ""
                }
                expenseObject.AccountProjectId = item.AccountProjectId === null ? expenseObject.AccountProjectId : item.AccountProjectId;
                expenseObject.AccountExpenseTypeId = item.AccountExpenseTypeId === null ? expenseObject.AccountExpenseTypeId : item.AccountExpenseTypeId;
                expenseObject.AccountExpenseId = item.AccountExpenseId === null ? expenseObject.AccountExpenseId : item.AccountExpenseId;
                expenseObject.Description = item.Description;
                expenseObject.ActualExpenseAmount = item.ActualExpenseAmount;
                expenseObject.BilledExpenseAmount = parseLocalizedNumber(item.BilledExpenseAmount) ?? 0//item.BilledExpenseAmount;
                expenseObject.AccountTaxCodeId1 = item.AccountTaxCodeId1 === null ? expenseObject.AccountTaxCodeId1 : item.AccountTaxCodeId1;
                expenseObject.AccountTaxCodeId2 = item.AccountTaxCodeId2 === null ? expenseObject.AccountTaxCodeId2 : item.AccountTaxCodeId2;
                expenseObject.TaxCode1 = item.TaxCode1 === null ? 0 : item.TaxCode1;
                expenseObject.TaxCode2 = item.TaxCode2 === null ? 0 : item.TaxCode2;
                expenseObject.AccountExpenseEntryId = item.AccountExpenseEntryId === null ? expenseObject.AccountExpenseEntryId : item.AccountExpenseEntryId;
                expenseObject.AccountTimeExpenseBillingExpenseId = item.AccountTimeExpenseBillingExpenseId === null ? expenseObject.AccountTimeExpenseBillingExpenseId : item.AccountTimeExpenseBillingExpenseId;
                AccountTimeExpenseBillingExpense.push(expenseObject);
            })
            // : AccountTimeExpenseBillingExpense.push({
            //     "AccountProjectId": 0,
            //     "AccountExpenseTypeId": 0,
            //     "AccountExpenseId": 0,
            //     "Description": "",
            //     "ActualExpenseAmount": 0,
            //     "BilledExpenseAmount": 0,
            //     "AccountTaxCodeId1": 0,
            //     "AccountTaxCodeId2": 0,
            //     "TaxCode1": 0,
            //     "TaxCode2": 0,
            //     "AccountExpenseEntryId": "0",
            //     "AccountTimeExpenseBillingExpenseId": ""
            // });
            let getMasterRecord: any = masterAccountTimeExpenseBilling[0];
            getMasterRecord = {
                ...getMasterRecord,
                BillingCycleEndDate: moment.parseZone(getMasterRecord.BillingCycleEndDate).format(dateInsertionFormat),
                BillingCycleStartDate: moment.parseZone(getMasterRecord.BillingCycleStartDate).format(dateInsertionFormat),
                InvoiceDate: moment.parseZone(getMasterRecord.InvoiceDate).format(dateInsertionFormat),
                InvoiceDueDate: moment.parseZone(getMasterRecord.InvoiceDueDate).format(dateInsertionFormat),
                GroupExpenseBillingListBy: getMasterRecord.GroupExpenseBillingListBy.replace(/\s/g, ''),
                Billable: getMasterRecord.Billable.toString(),
                InvoiceNo: getMasterRecord.InvoiceNo.toString(),
                InvoicePrefix: getMasterRecord.InvoicePrefix.toString(),
                EmailTo: "1@dummy.com",
                AccountTimeExpenseBillingId: getMasterRecord.AccountTimeExpenseBillingId
            }
            delete getMasterRecord.AccountTaxCodeId1;
            delete getMasterRecord.AccountTaxCodeId2;
            const data = {
                AccounTimeExpenseBilling: getMasterRecord,
                AccounTimeExpenseBillingTimesheet: AccountTimeExpenseBillingTimesheet,
                AccounTimeExpenseBillingExpense: AccountTimeExpenseBillingExpense
            };
            const response = await fetchAPI(`api/V2/Invoice/TimeExpenseBillingInvoice`, 'POST', data, true);
            const json = await response.json();
            return json;
        }
    )

// Xero work commet
// export const SendToXero = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         'Integrations/SendToXero',
//         async (arg, thunkApi) => {
//             const { commaSeparatedIds, xeroAccessToken, xeroTenantId, exportType } = arg;
//             const requestBody = [{
//                 commaSeparatedIds: commaSeparatedIds,
//                 xeroAccessToken: xeroAccessToken,
//                 xeroTenantId: xeroTenantId
//                //xeroAccessToken: localStorage.getItem('XeroAccessToken'),
//                //xeroTenantId: localStorage.getItem('XeroTenantId')
//             }];
//             const response = await fetchAPI(`api/V2/Integrations/SendToXero/${exportType}`, 'POST', requestBody, true);
//             const json = await response.json();
//             return json;
//         }
//     )

export const SendToXero = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Integrations/SendToXero',
        async (arg, thunkApi) => {
            const { commaSeparatedIds, exportType } = arg;
            const { sessionAccountId } = thunkApi.getState().globalState;
            const requestBody = [{ commaSeparatedIds: commaSeparatedIds, AccountId: sessionAccountId }];
            const response = await fetchAPI(`api/V2/Integrations/SendToXero/${exportType}`, 'POST', requestBody, true);
            const json = await response.json();
            return json;
        }
    )

export const deleteTimesheetBillingList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/deleteTimesheetBillingList',
        async (arg, thunkApi) => {
            //const masterRecord = masterAccountTimeExpenseBilling.find((item) => item.AccountTimeExpenseBillingId === currentItem.AccountTimeExpenseBillingId);
            const { timesheetBillingList, masterAccountTimeExpenseBilling } = thunkApi.getState().invoiceBilling;
            const { AccountTimeExpenseBillingId, AccountTimeExpenseBillingTimesheetId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryId } = timesheetBillingList.find((item) => item.AccountTimeExpenseBillingTimesheetId == arg);
            let getMasterRecord: any = masterAccountTimeExpenseBilling[0];
            getMasterRecord = {
                ...getMasterRecord,
                AccountTimeExpenseBillingId: AccountTimeExpenseBillingId
            }
            const response = await fetchAPI(`api/Invoice/DeleteAccountTimeExpenseBillingTimeSheetGridView/${AccountTimeExpenseBillingTimesheetId}/?AccountProjectId=${AccountProjectId ?? 0}&AccountProjectTaskId=${AccountProjectTaskId ?? 0}&AccountTimeEntryId=${AccountEmployeeTimeEntryId}`, 'DELETE', getMasterRecord, true);
            const json = await response.json();
            return json;
        }
    )

export const deleteExpenseBillingList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/deleteExpenseBillingList',
        async (arg, thunkApi) => {
            const { expenseBillingList, masterAccountTimeExpenseBilling } = thunkApi.getState().invoiceBilling;
            const { AccountTimeExpenseBillingId, AccountTimeExpenseBillingExpenseId, AccountProjectId, AccountExpenseId, AccountExpenseEntryId } = expenseBillingList.find((item) => item.AccountTimeExpenseBillingExpenseId == arg);
            let getMasterRecord: any = masterAccountTimeExpenseBilling[0];
            getMasterRecord = {
                ...getMasterRecord,
                AccountTimeExpenseBillingId: AccountTimeExpenseBillingId
            }
            const response = await fetchAPI(`api/Invoice/DeleteAccountTimeExpenseBillingExpenseGridView/${AccountTimeExpenseBillingExpenseId}/?AccountProjectId=${AccountProjectId}&AccountExpenseId=${AccountExpenseId}&AccountExpenseEntryId=${AccountExpenseEntryId}`, 'DELETE', getMasterRecord, true);
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountInvoiceForm = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/deleteAccountInvoiceForm',
        async (arg, thunkApi) => {
            const { timesheetBillingList, expenseBillingList, masterAccountTimeExpenseBilling } = thunkApi.getState().invoiceBilling;       
            let AccountTimeExpenseBillingTimesheet: any[] = [];
            let AccountTimeExpenseBillingExpense: any[] = [];
            if (arg.invoiceRecordsFor === -1 || arg.invoiceRecordsFor === 0) {
                timesheetBillingList.map((item) => {
                    AccountTimeExpenseBillingTimesheet.push({
                        "AccountTimeExpenseBillingTimesheetId": item.AccountTimeExpenseBillingTimesheetId,
                        "AccountTimeEntryId": item.AccountEmployeeTimeEntryId
                    });
                });
            }
            if (arg.invoiceRecordsFor === -1 || arg.invoiceRecordsFor === 1) {
                expenseBillingList.map((item) => {
                    AccountTimeExpenseBillingExpense.push({
                        "AccountTimeExpenseBillingExpenseId": item.AccountTimeExpenseBillingExpenseId,
                        "AccountExpenseEntryId": item.AccountExpenseEntryId
                    });
                });
            }
            let getMasterRecord: any = masterAccountTimeExpenseBilling[0];
            getMasterRecord = {
                ...getMasterRecord,
                BillingCycleEndDate: moment(getMasterRecord.BillingCycleEndDate).format('YYYY-MM-DD'),
                BillingCycleStartDate: moment(getMasterRecord.BillingCycleStartDate).format('YYYY-MM-DD'),
                InvoiceDate: moment(getMasterRecord.InvoiceDate).format('YYYY-MM-DD'),
                InvoiceDueDate: moment(getMasterRecord.InvoiceDueDate).format('YYYY-MM-DD'),
                GroupExpenseBillingListBy: getMasterRecord.GroupExpenseBillingListBy.replace(/\s/g, ''),
                Billable: getMasterRecord.Billable.toString(),
                InvoiceNo: getMasterRecord.InvoiceNo.toString(),
                EmailTo: "1@dummy.com"
            }
            delete getMasterRecord.AccountTaxCodeId1;
            delete getMasterRecord.AccountTaxCodeId2;
            const data = {
                TimeEntries: AccountTimeExpenseBillingTimesheet,
                ExpenseEntries: AccountTimeExpenseBillingExpense,
                AccountTimeExpenseBilling: getMasterRecord,
            };
            const response = await fetchAPI(`api/Invoice/DeleteAccountInvoiceEntries/${arg.AccountTimeExpenseBillingId}/${arg.invoiceRecordsFor}`, 'DELETE', data, true);
            const json = await response.json();
            return { ...json, invoiceRecordsFor: arg.invoiceRecordsFor };
        }
    )

export const deleteAccountTimeExpenseBilling = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/deleteAccountTimeExpenseBilling',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/Invoice/DeleteTimeExpenseBillingValue/${arg}`, 'DELETE', '', true);
            const json = await response.json();
            return json;
        }
    )

export const getAccountInvoiceTemplateByClientId = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/getAccountInvoiceTemplateByClientId',
        async (arg, thunkApi) => {
            const { sessionAccountId } = thunkApi.getState().globalState;
            const response = await fetchAPI(`api/V2/Invoice/GetAccountInvoiceTemplateByClientId/${sessionAccountId}/${arg}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const invoiceBillingSlice = createSlice({
    name: 'invoiceBilling',
    initialState,
    reducers: {
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsListLoading: (state, action: PayloadAction<boolean>) => {
            state.isListLoading = action.payload;
        },
        updateIsLoadingAndReload: (state, action: PayloadAction<boolean>) => {
            state.isReload = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        setAccountTimeExpenseBillingIdsState: (state, action) => {
            const { AccountTimeExpenseBillingId, isChecked } = action.payload;
        
            if (isChecked) {
                // Add the ID to the selectedIds array if it's not already present
                if (!state.AccountTimeExpenseBillingIds.includes(AccountTimeExpenseBillingId)) {
                    state.AccountTimeExpenseBillingIds.push(AccountTimeExpenseBillingId);
                }
            } else {
                // Remove the ID from the selectedIds array if it's present
                state.AccountTimeExpenseBillingIds = state.AccountTimeExpenseBillingIds.filter(Id => Id !== AccountTimeExpenseBillingId);
            }
            // Check if all items are selected
            const totalItems = state.timeExpenseInvoiceList.length;
            const selectedItemCount = state.AccountTimeExpenseBillingIds.length;

            // Update 'isAllChecked' based on the selection
            state.isAllChecked = totalItems > 0 && selectedItemCount === totalItems;
        },
        setAllAccountTimeExpenseBillingIdsState : (state, action) => {
            const isChecked = action.payload;

            if (isChecked) {
                // Add all IDs to selectedIds
                state.AccountTimeExpenseBillingIds = state.timeExpenseInvoiceList.map(item => item.AccountTimeExpenseBillingId);
            } else {
                // Clear all selected IDs
                state.AccountTimeExpenseBillingIds = [];
            }

            state.isAllChecked = isChecked;
        },
        checkedState: (state, action) => {
            const currentindex = state.timeExpenseInvoiceList.findIndex((item) => item.AccountTimeExpenseBillingId == action.payload);
            const newArray = [...state.timeExpenseInvoiceList];
            newArray[currentindex] = { ...newArray[currentindex], IsPaid: true, isSelected: 1 };
            state.timeExpenseInvoiceList = newArray;
            //
            if (state.checkedRecordsForBilled.includes(action.payload)) {
                const currentindex1 = state.checkedRecordsForBilled.indexOf(action.payload);
                const tempRemoveItem = state.checkedRecordsForBilled.filter((_, index) => index != Number(currentindex1));
                state.checkedRecordsForBilled = tempRemoveItem;
            } else {
                const newcheckedRecordsForBilled = [...state.checkedRecordsForBilled, action.payload];
                state.checkedRecordsForBilled = newcheckedRecordsForBilled;
            }
        },
        unCheckedState: (state, action) => {
            const currentindex = state.timeExpenseInvoiceList.findIndex((item) => item.AccountTimeExpenseBillingId == action.payload);
            const newArray = [...state.timeExpenseInvoiceList];
            newArray[currentindex] = { ...newArray[currentindex], IsPaid: false, isSelected: 1 };
            state.timeExpenseInvoiceList = newArray;
            //
            if (state.checkedRecordsForBilled.includes(action.payload)) {
                const currentindex1 = state.checkedRecordsForBilled.indexOf(action.payload);
                const tempRemoveItem = state.checkedRecordsForBilled.filter((_, index) => index != Number(currentindex1));
                state.checkedRecordsForBilled = tempRemoveItem;
            } else {
                const newcheckedRecordsForBilled = [...state.checkedRecordsForBilled, action.payload];
                state.checkedRecordsForBilled = newcheckedRecordsForBilled;
            }
        },
        updateAccountTimeExpenseBillingId: (state, action) => {
            state.accountTimeExpenseBillingId = action.payload;
        },
        addItemTimesheetBillingList: (state, action) => {
            state.timesheetBillingList = [...state.timesheetBillingList, action.payload];
        },
        // addItemTimesheetBillingListFromBilling: (state, action) => {
        //     state.timesheetBillingList = action.payload;
        // },
        removeItemInTimesheetBilling: (state, action) => {
            let tempArray: any[] = [];
            state.timesheetBillingList.map((item, index) => {
                if (index != action.payload) {
                    tempArray.push(item);
                }
                else {
                    const newArray = [...state.timesheetBillingList];
                    state.taxCode1 = state.taxCode1 - newArray[index].TaxCode1;
                    state.taxCode2 = state.taxCode2 - newArray[index].TaxCode2;
                    state.subTotal = state.subTotal - newArray[index].TotalAmount;
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2;
                    //BillingCycleEndDate = newArray[index].BillingCycleStartDate;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "SubTotal": state.subTotal,
                        "TaxCode1": state.taxCode1,
                        "TaxCode2": state.taxCode2,
                        "GrandTotal": state.grandTotal
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            })
            state.timesheetBillingList = tempArray;
        },
        updateAccountClientId: (state, action: PayloadAction<any>) => {
            state.accountClientId = action.payload;
            state.timesheetBillingList.map((item) => {
                item.AccountClientId = action.payload;
            });
            state.expenseBillingList.map((item) => {
                item.AccountClientId = action.payload;
            });
        },
        updateAccountProjectId: (state, action: PayloadAction<any>) => {
            state.accountProjectId = action.payload;
        },
        updateAccountProjectTaskId: (state, action: PayloadAction<any>) => {
            state.accountProjectTaskId = action.payload;
        },
        isEditableTimesheetList: (state, action) => {      
            let currentindex = state.timesheetBillingList.findIndex((item) => item.AccountTimeExpenseBillingTimesheetId == action.payload);
            if (currentindex === -1) {
                currentindex = state.timesheetBillingList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            }
            if (currentindex !== -1) {
                const newArray = [...state.timesheetBillingList];
                newArray[currentindex] = { ...newArray[currentindex], IsEditable: true };
                state.timesheetBillingList = newArray;
            }
        },
        isCancelTimesheetList: (state, action) => {
            let currentindex = state.timesheetBillingList.findIndex((item) => item.AccountTimeExpenseBillingTimesheetId == action.payload);
            if (currentindex === -1) {
                currentindex = state.timesheetBillingList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            }
            if (currentindex !== -1) {
                const newArray = [...state.timesheetBillingList];
                newArray[currentindex] = { ...newArray[currentindex], IsEditable: false };
                state.timesheetBillingList = newArray;
            }
        },
        addItemExpenseBillingList: (state, action) => {
            state.expenseBillingList = [...state.expenseBillingList, action.payload];
        },
        // addItemExpenseBillingListFromBilling: (state, action) => {
        //     state.expenseBillingList = action.payload;
        // },
        removeItemInExpenseBilling: (state, action) => {
            let tempArray: any[] = [];
            state.expenseBillingList.map((item, index) => {
                if (index != action.payload) {
                    tempArray.push(item);
                } else {
                    const newArray = [...state.expenseBillingList];
                    state.taxCode1 = state.taxCode1 - (newArray[index].TaxCode1 * Number(newArray[index].BilledExpenseAmount));
                    state.taxCode2 = state.taxCode2 - (newArray[index].TaxCode2 * Number(newArray[index].BilledExpenseAmount));
                    state.subTotal = state.subTotal - Number(newArray[index].BilledExpenseAmount);
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "SubTotal": state.subTotal,
                        "TaxCode1": state.taxCode1,
                        "TaxCode2": state.taxCode2,
                        "GrandTotal": state.grandTotal
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            })
            state.expenseBillingList = tempArray;
        },
        isEditableExpenseList: (state, action) => {
            let currentindex = state.expenseBillingList.findIndex(
                (item) => item.AccountTimeExpenseBillingExpenseId == action.payload.AccountTimeExpenseBillingExpenseId
            );

            if (currentindex === -1) {
                currentindex = state.expenseBillingList.findIndex(
                    (item) => item.AccountExpenseEntryId == action.payload.AccountExpenseEntryId
                );
            }
            if (currentindex !== -1) {
                const newArray = [...state.expenseBillingList];
                newArray[currentindex] = { 
                    ...newArray[currentindex], 
                    BilledExpenseAmount: formatNumberCustomoriginalapiv2(action.payload.cultureInfoName, newArray[currentindex].BilledExpenseAmount, 2), 
                    IsEditable: true 
                };
                state.expenseBillingList = newArray;
            }
        },
        isCancelExpenseList: (state, action) => {
            let currentindex = state.expenseBillingList.findIndex((item) => item.AccountTimeExpenseBillingExpenseId == action.payload);
            if (currentindex === -1) {
                currentindex = state.expenseBillingList.findIndex((item) => item.AccountExpenseEntryId == action.payload);
            }
            if (currentindex !== -1) {
                const newArray = [...state.expenseBillingList];
                newArray[currentindex] = { ...newArray[currentindex], 
                    BilledExpenseAmount: parseLocalizedNumber(newArray[currentindex].BilledExpenseAmount)//(action.payload.cultureInfoName, newArray[currentindex].BilledExpenseAmount, 2)
                    , IsEditable: false };
                state.expenseBillingList = newArray;

            }
            
        },  
updateTimesheetBillingValuesch: (state, action) => {

    const culture = 'fr-FR';
    const index = action.payload.index;

    const newArray = [...state.timesheetBillingList];
    newArray[index] = {
        ...newArray[index],
        [action.payload.item]: action.payload.value
    };

    // ===================== EXPENSE TOTALS =====================
    let expenseTotal = 0, expenseTaxCode1 = 0, expenseTaxCode2 = 0;

    state.expenseBillingList.forEach(e => {
        expenseTotal += parseCultureNumber(e.BilledExpenseAmount, culture);
        expenseTaxCode1 += parseCultureNumber(e.TaxCode1, culture);
        expenseTaxCode2 += parseCultureNumber(e.TaxCode2, culture);
    });

    const tax1Formula =
        state.accountTaxCodeList.find(x => x.value === newArray[index].AccountTaxCodeId1)?.Formula;

    const tax2Formula =
        state.accountTaxCodeList.find(x => x.value === newArray[index].AccountTaxCodeId2)?.Formula;

    // ===================== BILLING RATE =====================
    if (action.payload.item === "BillingRate" || action.payload.item === "BillHours") {

        const billingRate = parseCultureNumber(newArray[index].BillingRate, culture);
        const billHours = parseCultureNumber(newArray[index].BillHours, culture);
        const netAmount = billingRate * billHours;

        newArray[index] = {
            ...newArray[index],
            BillingRate: billingRate,
            BillHours: billHours,
            TotalAmount: netAmount,
            TaxCode1: tax1Formula?.includes('Net') ? eval(tax1Formula.replace(/Net/g, netAmount)) : 0,
            TaxCode2: tax2Formula?.includes('Net') ? eval(tax2Formula.replace(/Net/g, netAmount)) : 0
        };
    }

    // ===================== TAX CODE 1 =====================
    if (action.payload.item === "AccountTaxCodeId1") {
        const net = parseCultureNumber(newArray[index].TotalAmount, culture);
        const formula = state.accountTaxCodeList.find(x => x.value === action.payload.value)?.Formula;

        newArray[index].TaxCode1 =
            formula?.includes('Net') ? eval(formula.replace(/Net/g, net)) : 0;
    }

    // ===================== TAX CODE 2 =====================
    if (action.payload.item === "AccountTaxCodeId2") {
        const net = parseCultureNumber(newArray[index].TotalAmount, culture);
        const formula = state.accountTaxCodeList.find(x => x.value === action.payload.value)?.Formula;

        newArray[index].TaxCode2 =
            formula?.includes('Net') ? eval(formula.replace(/Net/g, net)) : 0;
    }

    state.timesheetBillingList = newArray;

    // ===================== FINAL TOTALS =====================
    let totalTime = 0, tax1 = 0, tax2 = 0;

    newArray.forEach(i => {
        totalTime += parseCultureNumber(i.TotalAmount, culture);
        tax1 += parseCultureNumber(i.TaxCode1, culture);
        tax2 += parseCultureNumber(i.TaxCode2, culture);
    });

    const discountValue =
        Number(state.masterAccountTimeExpenseBilling[0].ShowDiscountCalculationBy) === 0
            ? ((totalTime + expenseTotal) * state.discountPercentage) / 100
            : Number(state.discountPercentage);

    state.subTotal = totalTime + expenseTotal;
    state.taxCode1 = tax1 + expenseTaxCode1;
    state.taxCode2 = tax2 + expenseTaxCode2;
    state.discount = discountValue;
    state.grandTotal =
        state.subTotal + state.taxCode1 + state.taxCode2 - discountValue;

    state.masterAccountTimeExpenseBilling = [{
        ...state.masterAccountTimeExpenseBilling[0],
        SubTotal: state.subTotal,
        TaxCode1: state.taxCode1,
        TaxCode2: state.taxCode2,
        Discount: discountValue,
        GrandTotal: state.grandTotal
    }];
},
      
        updateTimesheetBillingValuesold: (state, action) => {
            const newArray = [...state.timesheetBillingList];
            newArray[action.payload.index] = { ...newArray[action.payload.index], [action.payload.item]: action.payload.value };
            state.timesheetBillingList = newArray;
            let expenseTotal = 0;
            let expenseTaxCode1 = 0;
            let expenseTaxCode2 = 0;
                            let strBilledExpenseAmount;
                let parsedNetAmount = 0;
                let strTotalAmount;
                let parsedTotalAmount = 0;
                let parsedBillingrate = 0;
                let strBillingRate;
            state.expenseBillingList.forEach(item => {
                                    const isCommaSeparator = determineCommaSeprater('fr-FR');
                        if (isCommaSeparator) {
                            strBilledExpenseAmount = String(item.BilledExpenseAmount).replace(',', '.');
                            parsedNetAmount = parseFloat(strBilledExpenseAmount)
                            
                        }
                expenseTotal = expenseTotal + Number(parsedNetAmount);
                expenseTaxCode1 = expenseTaxCode1 + item.TaxCode1;
                expenseTaxCode2 = expenseTaxCode2 + item.TaxCode2;
            });
            let formulaAccountTaxCodeId1 = state.accountTaxCodeList.filter(x => x.value === (newArray[action.payload.index].AccountTaxCodeId1 === null ? 0 : newArray[action.payload.index].AccountTaxCodeId1))[0].Formula;
            let formulaAccountTaxCodeId2 = state.accountTaxCodeList.filter(x => x.value === (newArray[action.payload.index].AccountTaxCodeId2 === null ? 0 : newArray[action.payload.index].AccountTaxCodeId2))[0].Formula;
            if (action.payload.item === "BillingRate") {
                const newMasterArray = [...state.masterAccountTimeExpenseBilling];

                let totalTime = 0;
                let temptaxCode1 = 0;
                let temptaxCode2 = 0;
                state.timesheetBillingList.forEach(item => {
                                        const isCommaSeparator = determineCommaSeprater('fr-FR');
                        if (isCommaSeparator) {
                            strBillingRate = String(item.BillingRate).replace(',', '.');
                            parsedBillingrate = parseFloat(strBillingRate)


                            
                        }
                        
                            const net = parsedBillingrate * Number(item.BillHours   );
                    totalTime = totalTime + Number(net);
                    temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    temptaxCode2 = temptaxCode2 + item.TaxCode2;
                });
                                newArray[action.payload.index] = {
                    ...newArray[action.payload.index],
                    "TotalAmount": formatNumberCustomoriginalapiv2('fr-FR', totalTime, 2),
                    "TaxCode1": (formulaAccountTaxCodeId1 != undefined && formulaAccountTaxCodeId1.search("Net") != -1) ? eval(formulaAccountTaxCodeId1.replace("Net", parsedTotalAmount * newArray[action.payload.index].BillHours)) : 0,
                    "TaxCode2": (formulaAccountTaxCodeId2 != undefined && formulaAccountTaxCodeId2.search("Net") != -1) ? eval(formulaAccountTaxCodeId2.replace("Net", parsedTotalAmount * newArray[action.payload.index].BillHours)) : 0
                };
                state.timesheetBillingList = newArray;
                let discountValue = Number(newMasterArray[0].ShowDiscountCalculationBy) == 0 ? (((totalTime + expenseTotal) * state.discountPercentage) / 100) : Number(state.discountPercentage);
                state.subTotal = totalTime + expenseTotal;
                state.taxCode1 = temptaxCode1 + expenseTaxCode1;
                state.taxCode2 = temptaxCode2 + expenseTaxCode2;
                state.grandTotal = totalTime + expenseTotal + state.taxCode1 + state.taxCode2 - discountValue;
                state.discount = discountValue;
                newMasterArray[0] = {
                    ...newMasterArray[0],
                    "SubTotal": (totalTime + expenseTotal),
                    "TaxCode1": (temptaxCode1 + expenseTaxCode1),
                    "TaxCode2": (temptaxCode2 + expenseTaxCode2),
                    "GrandTotal": (totalTime + expenseTotal + state.taxCode1 + state.taxCode2 - discountValue),
                    "Discount": discountValue
                };
                state.masterAccountTimeExpenseBilling = newMasterArray;
            } else if (action.payload.item === "BillHours") {
                                let strBillingRate;
                let parsedBillingRate = 0;
                const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                                                    const isCommaSeparator = determineCommaSeprater('fr-FR');
                        if (isCommaSeparator) {
                            strBillingRate = String(newArray[action.payload.index].BillingRate).replace(',', '.');
                            parsedBillingRate = parseFloat(strBillingRate)
                            
                        }
                newArray[action.payload.index] = {
                    ...newArray[action.payload.index],
                    "TotalAmount": action.payload.value * Number(parsedBillingRate),
                    "TaxCode1": (formulaAccountTaxCodeId1 != undefined && formulaAccountTaxCodeId1.search("Net") != -1) ? eval(formulaAccountTaxCodeId1.replace("Net", action.payload.value * newArray[action.payload.index].BillingRate)) : 0,
                    "TaxCode2": (formulaAccountTaxCodeId2 != undefined && formulaAccountTaxCodeId2.search("Net") != -1) ? eval(formulaAccountTaxCodeId2.replace("Net", action.payload.value * newArray[action.payload.index].BillingRate)) : 0
                };
                state.timesheetBillingList = newArray;
                let totalTime = 0;
                let temptaxCode1 = 0;
                let temptaxCode2 = 0;
                state.timesheetBillingList.forEach(item => {
                    totalTime = totalTime + item.TotalAmount;
                    temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    temptaxCode2 = temptaxCode2 + item.TaxCode2;
                });
                let discountValue = Number(newMasterArray[0].ShowDiscountCalculationBy) == 0 ? (((totalTime + expenseTotal) * state.discountPercentage) / 100) : Number(state.discountPercentage);
                state.subTotal = totalTime + expenseTotal;
                state.taxCode1 = temptaxCode1 + expenseTaxCode1;
                state.taxCode2 = temptaxCode2 + expenseTaxCode2;
                state.grandTotal = totalTime + expenseTotal + state.taxCode1 + state.taxCode2 - discountValue;
                state.discount = discountValue;
                newMasterArray[0] = {
                    ...newMasterArray[0],
                    "SubTotal": (totalTime + expenseTotal),
                    "TaxCode1": (temptaxCode1 + expenseTaxCode1),
                    "TaxCode2": (temptaxCode2 + expenseTaxCode2),
                    "GrandTotal": (totalTime + expenseTotal + state.taxCode1 + state.taxCode2 - discountValue),
                    "Discount": discountValue
                };
                state.masterAccountTimeExpenseBilling = newMasterArray;
            } else if (action.payload.item === "AccountTaxCodeId1") {
                let strBilledTaxCode1;
                let parsedTaxCode1 = 0;

                    const isCommaSeparator = determineCommaSeprater('fr-FR');
                        if (isCommaSeparator) {
                            strBilledTaxCode1 = String(newArray[action.payload.index].TotalAmount).replace(',', '.');
                            parsedTaxCode1 = parseFloat(strBilledTaxCode1)
                            }
                            
                let formula = state.accountTaxCodeList.filter(x => x.value === action.payload.value)[0].Formula;
                if (formula != undefined && formula.search("Net") != -1) {
                    let formulaToBeParsed = formula.replace("Net", parsedTaxCode1);

                        
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode1": eval(formulaToBeParsed)
                    }
                    state.timesheetBillingList = newArray;
                    let temptaxCode1 = 0;
                    state.timesheetBillingList.forEach(item => {
                        temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    });
                    state.taxCode1 = temptaxCode1 + expenseTaxCode1;
                    state.grandTotal = state.subTotal + state.taxCode2 + state.taxCode1 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode1": (temptaxCode1 + expenseTaxCode1),
                        "GrandTotal": (state.subTotal + state.taxCode2 + state.taxCode1 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                } else {
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode1": 0
                    }
                    state.timesheetBillingList = newArray;
                    let temptaxCode1 = 0;
                    state.timesheetBillingList.forEach(item => {
                        temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    })
                    state.taxCode1 = temptaxCode1 + expenseTaxCode1;
                    state.grandTotal = state.subTotal + state.taxCode2 + state.taxCode1 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode1": (temptaxCode1 + expenseTaxCode1),
                        "GrandTotal": (state.subTotal + state.taxCode2 + state.taxCode1 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            } else if (action.payload.item === "AccountTaxCodeId2") {
                let formula = state.accountTaxCodeList.filter(x => x.value === action.payload.value)[0].Formula;
                                let strBilledTaxCode2;
                let parsedTaxCode2 = 0;

                    const isCommaSeparator = determineCommaSeprater('fr-FR');
                        if (isCommaSeparator) {
                            strBilledTaxCode2 = String(newArray[action.payload.index].TotalAmount).replace(',', '.');
                            parsedTaxCode2 = parseFloat(strBilledTaxCode2)
                            }
                            
                if (formula != undefined && formula.search("Net") != -1) {
                    let formulaToBeParsed = formula.replace("Net", parsedTaxCode2);
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode2": eval(formulaToBeParsed)
                    }
                    state.timesheetBillingList = newArray;
                    let temptaxCode2 = 0;
                    state.timesheetBillingList.forEach(item => {
                        temptaxCode2 = temptaxCode2 + item.TaxCode2;
                    })
                    state.taxCode2 = temptaxCode2 + expenseTaxCode2;
                    state.grandTotal = state.subTotal + state.taxCode2 + state.taxCode1 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode2": (temptaxCode2 + expenseTaxCode2),
                        "GrandTotal": (state.subTotal + state.taxCode2 + state.taxCode1 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                } else {
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode2": 0
                    }
                    state.timesheetBillingList = newArray;
                    let temptaxCode2 = 0;
                    state.timesheetBillingList.forEach(item => {
                        temptaxCode2 = temptaxCode2 + item.TaxCode2;
                    })
                    state.taxCode2 = temptaxCode2 + expenseTaxCode2;
                    state.grandTotal = state.subTotal + state.taxCode2 + state.taxCode1 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode2": (temptaxCode2 + expenseTaxCode2),
                        "GrandTotal": (state.subTotal + state.taxCode2 + state.taxCode1 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            }
        },
        updateTimesheetBillingValues: (state, action) => {
    const { index, item, value } = action.payload;
    const isCommaSeparator = determineCommaSeprater(action.payload.cultureInfoName);
    
    // Helper to parse locale-specific numbers
    const parseLocaleNumber = (val: any) => {
        if (!isCommaSeparator) return Number(val);
        return parseFloat(String(val).replace(',', '.'));
    };

    // Helper to get tax formula
    const getTaxFormula = (taxCodeId:any) => {
        const taxCode = state.accountTaxCodeList.find(
            x => x.value === (taxCodeId ?? 0)
        );
        return taxCode?.Formula;
    };

    // Helper to evaluate tax formula
    const evaluateTax = (formula:any, netAmount:any) => {
        if (!formula || !formula.includes("Net")) return 0;
        return eval(formula.replace("Net", netAmount));
    };

    // Calculate expense totals once
    const expenseTotals = state.expenseBillingList.reduce((acc, item) => {
        const netAmount = parseLocaleNumber(item.BilledExpenseAmount);
        return {
            total: acc.total + netAmount,
            taxCode1: acc.taxCode1 + item.TaxCode1,
            taxCode2: acc.taxCode2 + item.TaxCode2
        };
    }, { total: 0, taxCode1: 0, taxCode2: 0 });

    // Update the specific item
    const updatedList = [...state.timesheetBillingList];
    updatedList[index] = { ...updatedList[index], [item]: value };

    const currentItem = updatedList[index];
    const formula1 = getTaxFormula(currentItem.AccountTaxCodeId1);
    const formula2 = getTaxFormula(currentItem.AccountTaxCodeId2);

    // Handle different update scenarios
    switch (item) {       
        case "BillingRate": {
        const billingRate = parseLocaleNumber(value);
        const billHours = parseLocaleNumber(currentItem.BillHours);

        const netAmount = billingRate * billHours;

        updatedList[index] = {
            ...currentItem,
            TotalAmount: formatNumberCustomoriginalapiv2(
                action.payload.cultureInfoName,
                netAmount,
                2
            ),
            TaxCode1: evaluateTax(formula1, netAmount),
            TaxCode2: evaluateTax(formula2, netAmount)
        };
        break;
    }

    case "BillHours": {
        const billHours = parseLocaleNumber(value);
        const billingRate = parseLocaleNumber(currentItem.BillingRate);

        const netAmount = billingRate * billHours;

        updatedList[index] = {
            ...currentItem,
            TotalAmount: formatNumberCustomoriginalapiv2(
                action.payload.cultureInfoName,
                netAmount,
                2
            ),
            TaxCode1: evaluateTax(formula1, netAmount),
            TaxCode2: evaluateTax(formula2, netAmount)
        };
        break;
    }

        case "AccountTaxCodeId1": {
            const totalAmount = parseLocaleNumber(currentItem.TotalAmount);
            const formula = getTaxFormula(value);
            
            updatedList[index] = {
                ...currentItem,
                TaxCode1: evaluateTax(formula, totalAmount)
            };
            break;
        }

        case "AccountTaxCodeId2": {
            const totalAmount = parseLocaleNumber(currentItem.TotalAmount);
            const formula = getTaxFormula(value);
            
            updatedList[index] = {
                ...currentItem,
                TaxCode2: evaluateTax(formula, totalAmount)
            };
            break;
        }
    }

    state.timesheetBillingList = updatedList;

    // Calculate timesheet totals
    const timesheetTotals = updatedList.reduce((acc, item) => {
        const totalAmount = parseLocaleNumber(item.TotalAmount || 0);
        return {
            total: acc.total + totalAmount,
            taxCode1: acc.taxCode1 + (item.TaxCode1 || 0),
            taxCode2: acc.taxCode2 + (item.TaxCode2 || 0)
        };
    }, { total: 0, taxCode1: 0, taxCode2: 0 });

    // Calculate grand totals
    const subTotal = timesheetTotals.total + expenseTotals.total;
    const taxCode1 = timesheetTotals.taxCode1 + expenseTotals.taxCode1;
    const taxCode2 = timesheetTotals.taxCode2 + expenseTotals.taxCode2;

    const masterArray = [...state.masterAccountTimeExpenseBilling];
    const showDiscountBy = Number(masterArray[0].ShowDiscountCalculationBy);
    const discount = showDiscountBy === 0 
        ? (subTotal * state.discountPercentage) / 100
        : Number(state.discountPercentage);

    const grandTotal = subTotal + taxCode1 + taxCode2 - discount;

    // Update state
    state.subTotal = subTotal;
    state.taxCode1 = taxCode1;
    state.taxCode2 = taxCode2;
    state.discount = discount;
    state.grandTotal = grandTotal;

    masterArray[0] = {
        ...masterArray[0],
        SubTotal: subTotal,
        TaxCode1: taxCode1,
        TaxCode2: taxCode2,
        Discount: discount,
        GrandTotal: grandTotal
    };
    state.masterAccountTimeExpenseBilling = masterArray;
},
updateExpenseBillingValues: (state, action) => {
    
    const { index, item, value } = action.payload;
    const isCommaSeparator = determineCommaSeprater(action.payload.cultureInfoName);
    
    // Helper to parse locale-specific numbers
    const parseLocaleNumber = (val: any) => {
        if (!isCommaSeparator) return Number(val);
        return parseFloat(String(val).replace(',', '.'));
    };

    // Helper to get tax formula
    const getTaxFormula = (taxCodeId:any) => {
        const taxCode = state.accountTaxCodeList.find(
            x => x.value === (taxCodeId ?? 0)
        );
        return taxCode?.Formula;
    };

    // Helper to evaluate tax formula
    const evaluateTax = (formula: any, netAmount: any) => {
        if (!formula || !formula.includes("Net")) return 0;
        return eval(formula.replace("Net", netAmount));
    };

    // Calculate timesheet totals once
    const timesheetTotals = state.timesheetBillingList.reduce((acc, item) => {
        const totalAmount = parseLocaleNumber(item.TotalAmount || 0);
        return {
            total: acc.total + totalAmount,
            taxCode1: acc.taxCode1 + (item.TaxCode1 || 0),
            taxCode2: acc.taxCode2 + (item.TaxCode2 || 0)
        };
    }, { total: 0, taxCode1: 0, taxCode2: 0 });

    // Update the specific expense item
    const updatedList = [...state.expenseBillingList];
    updatedList[index] = { ...updatedList[index], [item]: value };

    const currentItem = updatedList[index];
    const formula1 = getTaxFormula(currentItem.AccountTaxCodeId1);
    const formula2 = getTaxFormula(currentItem.AccountTaxCodeId2);

    // Handle different update scenarios
    switch (item) {
        case "BilledExpenseAmount": {
            const expenseAmount = parseLocaleNumber(value);
            
            updatedList[index] = {
                ...currentItem,
                TaxCode1: evaluateTax(formula1, expenseAmount),
                TaxCode2: evaluateTax(formula2, expenseAmount)
            };
            break;
        }

        case "AccountTaxCodeId1": {
            const expenseAmount = parseLocaleNumber(currentItem.BilledExpenseAmount || 0);
            const formula = getTaxFormula(value);
            
            updatedList[index] = {
                ...currentItem,
                TaxCode1: evaluateTax(formula, expenseAmount)
            };
            break;
        }

        case "AccountTaxCodeId2": {
            const expenseAmount = parseLocaleNumber(currentItem.BilledExpenseAmount || 0);
            const formula = getTaxFormula(value);
            
            updatedList[index] = {
                ...currentItem,
                TaxCode2: evaluateTax(formula, expenseAmount)
            };
            break;
        }
    }

    state.expenseBillingList = updatedList;

    // Calculate expense totals
    const expenseTotals = updatedList.reduce((acc, item) => {
        const expenseAmount = parseLocaleNumber(item.BilledExpenseAmount || 0);
        return {
            total: acc.total + expenseAmount,
            taxCode1: acc.taxCode1 + (item.TaxCode1 || 0),
            taxCode2: acc.taxCode2 + (item.TaxCode2 || 0)
        };
    }, { total: 0, taxCode1: 0, taxCode2: 0 });

    // Calculate grand totals
    const subTotal = timesheetTotals.total + expenseTotals.total;
    const taxCode1 = expenseTotals.taxCode1 + timesheetTotals.taxCode1;
    const taxCode2 = expenseTotals.taxCode2 + timesheetTotals.taxCode2;

    const masterArray = [...state.masterAccountTimeExpenseBilling];
    const showDiscountBy = Number(masterArray[0].ShowDiscountCalculationBy);
    const discount = showDiscountBy === 0 
        ? (subTotal * state.discountPercentage) / 100
        : Number(state.discountPercentage);

    const grandTotal = subTotal + taxCode1 + taxCode2 - discount;

    // Update state
    state.subTotal = subTotal;
    state.taxCode1 = taxCode1;
    state.taxCode2 = taxCode2;
    state.discount = discount;
    state.grandTotal = grandTotal;

    masterArray[0] = {
        ...masterArray[0],
        SubTotal: subTotal,
        TaxCode1: taxCode1,
        TaxCode2: taxCode2,
        Discount: discount,
        GrandTotal: grandTotal
    };
    state.masterAccountTimeExpenseBilling = masterArray;
},
        updateExpenseBillingValuesold: (state, action) => {
            const newArray = [...state.expenseBillingList];
            newArray[action.payload.index] = { ...newArray[action.payload.index], [action.payload.item]: action.payload.value };
            state.expenseBillingList = newArray;
            let timesheetTotal = 0;
            let timesheetTaxCode1 = 0;
            let timesheetTaxCode2 = 0;
            state.timesheetBillingList.forEach(item => {
                timesheetTotal = timesheetTotal + Number(item.TotalAmount);
                timesheetTaxCode1 = timesheetTaxCode1 + item.TaxCode1;
                timesheetTaxCode2 = timesheetTaxCode2 + item.TaxCode2;
            });
            let formulaAccountTaxCodeId1 = state.accountTaxCodeList.filter(x => x.value === (newArray[action.payload.index].AccountTaxCodeId1 === null ? 0 : newArray[action.payload.index].AccountTaxCodeId1))[0].Formula;
            let formulaAccountTaxCodeId2 = state.accountTaxCodeList.filter(x => x.value === (newArray[action.payload.index].AccountTaxCodeId2 === null ? 0 : newArray[action.payload.index].AccountTaxCodeId2))[0].Formula;
            if (action.payload.item === "BilledExpenseAmount") {
                const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                newArray[action.payload.index] = {
                    ...newArray[action.payload.index],
                    "TaxCode1": (formulaAccountTaxCodeId1 != undefined && formulaAccountTaxCodeId1.search("Net") != -1) ? eval(formulaAccountTaxCodeId1.replace("Net", Number(action.payload.value))) : 0,
                    "TaxCode2": (formulaAccountTaxCodeId2 != undefined && formulaAccountTaxCodeId2.search("Net") != -1) ? eval(formulaAccountTaxCodeId2.replace("Net", Number(action.payload.value))) : 0
                };
                state.expenseBillingList = newArray;
                let totalTime = 0;
                let tempTaxCode1 = 0;
                let tempTaxCode2 = 0;
                state.expenseBillingList.forEach(item => {
                    totalTime = totalTime + Number(item.BilledExpenseAmount);
                    tempTaxCode1 = tempTaxCode1 + item.TaxCode1;
                    tempTaxCode2 = tempTaxCode2 + item.TaxCode2;
                });
                let discountValue = Number(newMasterArray[0].ShowDiscountCalculationBy) == 0 ? (((timesheetTotal + totalTime) * state.discountPercentage) / 100) : Number(state.discountPercentage);
                state.subTotal = timesheetTotal + totalTime;
                state.taxCode1 = tempTaxCode1 + timesheetTaxCode1;
                state.taxCode2 = tempTaxCode2 + timesheetTaxCode2;
                state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2 - discountValue;
                state.discount = discountValue;
                newMasterArray[0] = {
                    ...newMasterArray[0],
                    "SubTotal": (timesheetTotal + totalTime),
                    "TaxCode1": (tempTaxCode1 + timesheetTaxCode1),
                    "TaxCode2": (tempTaxCode2 + timesheetTaxCode2),
                    "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2 - discountValue),
                    "Discount": discountValue
                };
                state.masterAccountTimeExpenseBilling = newMasterArray;
            } else if (action.payload.item === "AccountTaxCodeId1") {
                let formula = state.accountTaxCodeList.filter(x => x.value === action.payload.value)[0].Formula;
                if (formula != undefined && formula.search("Net") != -1) {
                    let formulaToBeParsed = formula.replace("Net", Number(newArray[action.payload.index].BilledExpenseAmount));
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode1": eval(formulaToBeParsed)
                    }
                    state.expenseBillingList = newArray;
                    let temptaxCode1 = 0;
                    state.expenseBillingList.forEach(item => {
                        temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    });
                    state.taxCode1 = temptaxCode1 + timesheetTaxCode1;
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode1": (temptaxCode1 + timesheetTaxCode1),
                        "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                } else {
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode1": 0
                    }
                    state.expenseBillingList = newArray;
                    let temptaxCode1 = 0;
                    state.expenseBillingList.forEach(item => {
                        temptaxCode1 = temptaxCode1 + item.TaxCode1;
                    })
                    state.taxCode1 = temptaxCode1 + timesheetTaxCode1;
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode1": (temptaxCode1 + timesheetTaxCode1),
                        "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            } else if (action.payload.item === "AccountTaxCodeId2") {
                let formula = state.accountTaxCodeList.filter(x => x.value === action.payload.value)[0].Formula;
                if (formula != undefined && formula.search("Net") != -1) {
                    let formulaToBeParsed = formula.replace("Net", Number(newArray[action.payload.index].BilledExpenseAmount));
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode2": eval(formulaToBeParsed)
                    }
                    state.expenseBillingList = newArray;
                    let temptaxCode2 = 0;
                    state.expenseBillingList.forEach(item => {
                        temptaxCode2 = temptaxCode2 + item.TaxCode2;
                    });
                    state.taxCode2 = temptaxCode2 + timesheetTaxCode2;
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode2": (temptaxCode2 + timesheetTaxCode2),
                        "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                } else {
                    newArray[action.payload.index] = {
                        ...newArray[action.payload.index],
                        "TaxCode2": 0
                    }
                    state.expenseBillingList = newArray;
                    let temptaxCode2 = 0;
                    state.expenseBillingList.forEach(item => {
                        temptaxCode2 = temptaxCode2 + item.TaxCode2;
                    })
                    state.taxCode2 = temptaxCode2 + timesheetTaxCode2;
                    state.grandTotal = state.subTotal + state.taxCode1 + state.taxCode2 - state.discount;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "TaxCode2": (temptaxCode2 + timesheetTaxCode2),
                        "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2 - state.discount)
                    };
                    state.masterAccountTimeExpenseBilling = newMasterArray;
                }
            }
        },
        updateDiscountValues: (state, action) => {
            console.log('abc action.payload', action.payload)
            let discountValue = Number(state.masterAccountTimeExpenseBilling[0].ShowDiscountCalculationBy) == 0 ? ((state.subTotal * Number(action.payload)) / 100) : Number(action.payload);
            state.discount = discountValue;
            
            state.grandTotal = (state.subTotal + state.taxCode1 + state.taxCode2) - discountValue;
            state.discountPercentage = Number(action.payload);
            const newMasterArray = [...state.masterAccountTimeExpenseBilling];
            newMasterArray[0] = {
                ...newMasterArray[0],
                "Discount": discountValue,
                "DiscountPercentage": action.payload,
                "GrandTotal": (state.subTotal + state.taxCode1 + state.taxCode2) - discountValue
            };
            state.masterAccountTimeExpenseBilling = newMasterArray;
        },
        updateMasterTimeExpenseBilling: (state, action) => {
            state.masterAccountTimeExpenseBilling = action.payload;
            const { SubTotal, TaxCode1, TaxCode2, GrandTotal, Discount, DiscountPercentage } = action.payload[0];
            state.subTotal = SubTotal;
            state.taxCode1 = TaxCode1;
            state.taxCode2 = TaxCode2;
            state.grandTotal = GrandTotal;
            state.discount = Discount;
            state.discountPercentage = DiscountPercentage;
        },
        updateMasterTimeExpenseBillingValues: (state, action) => {
            const newArray = [...state.masterAccountTimeExpenseBilling];
            newArray[0] = { ...newArray[0], [action.payload.item]: action.payload.value };
            state.masterAccountTimeExpenseBilling = newArray;
        },
        updateMasterTimeExpenseBillingValuesByClient: (state, action) => {
            const newArray = [...state.masterAccountTimeExpenseBilling];
            for (let key in action.payload) {
                newArray[0] = { ...newArray[0], [action.payload[key].item]: action.payload[key].value };
            }
            state.masterAccountTimeExpenseBilling = newArray;
        },
        updateAccountProjectTaskArray: (state, action) => {
            const newArray = [...state.timesheetBillingList];
            newArray[action.payload.index] = { ...newArray[action.payload.index], "ProjectTaskArray": action.payload.taskArray };
            state.timesheetBillingList = newArray;
        },
        updateProjectAndTaskInTimesheetList: (state, action) => {
            const newArray = [...state.timesheetBillingList];
            for (let key in action.payload) {
                newArray[action.payload[key].index] = { ...newArray[action.payload[key].index], [action.payload[key].item]: action.payload[key].value };
            }
            state.timesheetBillingList = newArray;
        },
        updateProjectAndTaskInExpenseList: (state, action) => {
            const newArray = [...state.expenseBillingList];
            for (let key in action.payload) {
                newArray[action.payload[key].index] = { ...newArray[action.payload[key].index], [action.payload[key].item]: action.payload[key].value };
            }
            state.expenseBillingList = newArray;
        },
        reCalculateInvoiceTotal: (state, action) => {
            state.subTotal = action.payload.SubTotal;
            state.discount = action.payload.Discount;
            state.taxCode1 = action.payload.TaxCode1;
            state.taxCode2 = action.payload.TaxCode2;
            state.grandTotal = action.payload.GrandTotal;
            state.discountPercentage = action.payload.DiscountPercentage;
            const newArray = [...state.masterAccountTimeExpenseBilling];
            newArray[0] = {
                ...newArray[0],
                "Discount": action.payload.Discount,
                "DiscountPercentage": action.payload.DiscountPercentage,
                "GrandTotal": action.payload.GrandTotal,
                "ShowDiscountCalculationBy": action.payload.ShowDiscountCalculationBy,
                "SubTotal": action.payload.SubTotal,
                "TaxCode1": action.payload.TaxCode1,
                "TaxCode2": action.payload.TaxCode2
            };
            state.masterAccountTimeExpenseBilling = newArray;
        },
        deleteItemInTimesheetBilling: (state, action) => {
            const currentItem = state.timesheetBillingList.find((item) => item.AccountTimeExpenseBillingTimesheetId == action.payload.id);
            //const masterId = state.timesheetBillingList.find((item) => item.AccountTimeExpenseBillingId == action.payload.accountTimeExpenseBillingId);
            const newMasterArray = [...state.masterAccountTimeExpenseBilling];
            let tempSubTotal = state.subTotal - currentItem.TotalAmount;
            let tempTaxCode1 = state.taxCode1 - currentItem.TaxCode1;
            let tempTaxCode2 = state.taxCode2 - currentItem.TaxCode2;
            let discountValue = Number(newMasterArray[0].ShowDiscountCalculationBy) == 0 ? ((tempSubTotal * state.discountPercentage) / 100) : Number(state.discountPercentage);
            state.subTotal = tempSubTotal;
            state.taxCode1 = tempTaxCode1;
            state.taxCode2 = tempTaxCode2;
            state.discount = discountValue;
            let tempGrandTotal = tempSubTotal + tempTaxCode1 + tempTaxCode2 - discountValue;
            state.grandTotal = tempGrandTotal;
            newMasterArray[0] = {
                ...newMasterArray[0],
                "SubTotal": tempSubTotal,
                "TaxCode1": tempTaxCode1,
                "TaxCode2": tempTaxCode2,
                "GrandTotal": tempGrandTotal,
                "Discount": discountValue
            };
            state.masterAccountTimeExpenseBilling = newMasterArray;
        },
        deleteItemInExpenseBilling: (state, action) => {
            const currentItem = state.expenseBillingList.find((item) => item.AccountTimeExpenseBillingExpenseId == action.payload.id);
            const newMasterArray = [...state.masterAccountTimeExpenseBilling];
            let tempSubTotal = state.subTotal - currentItem.BilledExpenseAmount;
            let tempTaxCode1 = state.taxCode1 - currentItem.TaxCode1;
            let tempTaxCode2 = state.taxCode2 - currentItem.TaxCode2;
            let discountValue = Number(newMasterArray[0].ShowDiscountCalculationBy) == 0 ? ((tempSubTotal * state.discountPercentage) / 100) : Number(state.discountPercentage);
            state.subTotal = tempSubTotal;
            state.taxCode1 = tempTaxCode1;
            state.taxCode2 = tempTaxCode2;
            state.discount = discountValue;
            let tempGrandTotal = tempSubTotal + tempTaxCode1 + tempTaxCode2 - discountValue;
            state.grandTotal = tempGrandTotal;
            newMasterArray[0] = {
                ...newMasterArray[0],
                "SubTotal": tempSubTotal,
                "TaxCode1": tempTaxCode1,
                "TaxCode2": tempTaxCode2,
                "GrandTotal": tempGrandTotal,
                "Discount": discountValue
            };
            state.masterAccountTimeExpenseBilling = newMasterArray;
        },
        removeProjectAndTaskInBothList: (state) => {
            state.timesheetBillingList.map(item => {
                item.AccountProjectId = 0;
                item.ProjectName = "None";
                item.AccountProjectTaskId = 0;
                item.TaskName = "None"
            });
            state.expenseBillingList.map(item => {
                item.AccountProjectId = 0;
                item.ProjectName = "None";
            });
        },
        updateTimeExpenseBillingIdForPrint: (state, action) => {
            state.accountTimeExpenseBillingIdForPrint = action.payload;
            state.accountTimeExpenseBillingId = action.payload;
        },
        resetInvoiceFormLists: (state, action) => {
            state.expenseBillingList = action.payload;
            state.timesheetBillingList = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },
        UpdateMasterCurrencyExchangeRate: (state, action: PayloadAction<number>) => {
            state.masterCurrencyExchangeRate = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTimeExpenseInvoiceList.pending, (state) => {
                state.status = 'loading';
                state.isListLoading = true;
                state.timeExpenseInvoiceList = [];                
            })
            .addCase(getTimeExpenseInvoiceList.fulfilled, (state, action) => {
                console.log('getTimeExpenseInvoiceList', getTimeExpenseInvoiceList)
                let timeExpenseInvoice = JSON.parse(action.payload.data);
                   if (timeExpenseInvoice.length > 0) {
                    timeExpenseInvoice.map((item: any) => {
                        item.isSelected = 0;
                    });
                    state.timeExpenseInvoiceList = timeExpenseInvoice;
                }               
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.checkedRecordsForBilled = [];
                state.status = 'idle';
                state.isListLoading = false;
                state.isReload = false;
            })
            .addCase(getTimeExpenseInvoiceList.rejected, (state) => {
                state.status = 'failed';
                state.isListLoading = false;
                state.isReload = false;
            })
            .addCase(getAllDataInSingleRequestForInvoiceForm.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAllDataInSingleRequestForInvoiceForm.fulfilled, (state, action) => {
                action.payload.AccountTaxCode.length > 0 && action.payload.AccountTaxCode.map((item: any) => {
                    item.value = item.AccountTaxCodeId;
                    item.label = item.TaxCode;
                    delete item.AccountTaxCodeId;
                    delete item.TaxCode;
                });
                action.payload.AccountTaxCode.unshift({ value: 0, label: 'Select' });
                state.accountTaxCodeList = action.payload.AccountTaxCode;
                let tempExpenseName: any[] = [];
                let tempExpenseType: any[] = [];
                action.payload.AccountExpense.length > 0 && action.payload.AccountExpense.map((item: any, index: number) => {
                    tempExpenseName.push({
                        "value": item.AccountExpenseId,
                        "label": item.AccountExpenseName
                    });
                    !tempExpenseType.some(e => e.value === item.AccountExpenseTypeId) && tempExpenseType.push({
                        "value": item.AccountExpenseTypeId,
                        "label": item.ExpenseType
                    })
                });
                tempExpenseName.unshift({ value: 0, label: 'Select' });
                tempExpenseType.unshift({ value: 0, label: 'Select' });
                state.accountExpenseNameList = tempExpenseName;
                state.accountExpenseTypeList = tempExpenseType;
                state.status = 'idle';
                // state.isLoading = false;
                // state.isReload = false;
            })
            .addCase(getAllDataInSingleRequestForInvoiceForm.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            //
            .addCase(getInvoiceMasterandDetailRecordsList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getInvoiceMasterandDetailRecordsList.fulfilled, (state, action) => {
               
                let tempInvoiceInformation = action.payload.Data[0];
                const billingCycleStartDate = tempInvoiceInformation[0].BillingCycleStartDate;
                //state.masterCurrencyCode = tempInvoiceInformation[0].CurrencyCode;
                const formattedDate = billingCycleStartDate && !isNaN(Date.parse(billingCycleStartDate))
               ? new Date(billingCycleStartDate).toISOString()
               : new Date().toISOString();
                const billingCycleendDate = tempInvoiceInformation[0].BillingCycleEndDate;
                const formattedEndDate = billingCycleendDate && !isNaN(Date.parse(billingCycleendDate))
               ? new Date(billingCycleendDate).toISOString()
               : new Date().toISOString();
                const InvoiceDate = tempInvoiceInformation[0].InvoiceDate;
                const formattedInvoiceDate = InvoiceDate && !isNaN(Date.parse(InvoiceDate))
               ? new Date(InvoiceDate).toISOString()
               : new Date().toISOString();
                const DueDate = tempInvoiceInformation[0].DueDate;
                const formattedDueDate = DueDate && !isNaN(Date.parse(DueDate))
               ? new Date(DueDate).toISOString()
               : new Date().toISOString();
                if (tempInvoiceInformation.length > 0) {
                    // console.log("tempInvoiceInformation[0]", tempInvoiceInformation[0])
                    // state.subTotal = tempInvoiceInformation[0].SubTotal;
                    // state.discount = tempInvoiceInformation[0].Discount;
                    // state.dueDate = tempInvoiceInformation[0].DueDate;
                    // let tempTaxCode1 = 0;
                    // let tempTaxCode2 = 0;
                    // action.payload.Data[1].length > 0 && action.payload.Data[1].forEach((item: any) => {
                    //     tempTaxCode1 = tempTaxCode1 + item.TaxCode1;
                    //     tempTaxCode2 = tempTaxCode2 + item.TaxCode2;
                    // });
                    // action.payload.Data[2].length > 0 && action.payload.Data[2].forEach((item: any) => {
                    //     tempTaxCode1 = tempTaxCode1 + item.TaxCode1;
                    //     tempTaxCode2 = tempTaxCode2 + item.TaxCode2;
                    // });
                    // state.taxCode1 = (state.taxCode1 + tempTaxCode1);
                    // state.taxCode2 = (state.taxCode2 + tempTaxCode2);
                    // state.grandTotal = ((tempInvoiceInformation[0].SubTotal + state.taxCode1 + state.taxCode2) - tempInvoiceInformation[0].Discount);
                    // state.discountPercentage = tempInvoiceInformation[0].DiscountPercentage;
                    // const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    // newMasterArray[0] = {
                    //     ...newMasterArray[0],
                    //     //"SubTotal": state.subTotal,
                    //     "TaxCode1": state.taxCode1,
                    //     "TaxCode2": state.taxCode2,
                    //     //"GrandTotal": state.grandTotal,
                    //     //"Discount": tempInvoiceInformation[0].Discount
                    //     //"DiscountPercentage": tempInvoiceInformation[0].DiscountPercentage
                    // };
                    // state.masterAccountTimeExpenseBilling = newMasterArray;
                    const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                    // newMasterArray[0] = {
                    //     ...newMasterArray[0],
                    //     "AccountClientId": tempInvoiceInformation[0].AccountClientId,
                    //     "AccountTimeExpenseBillingId": tempInvoiceInformation[0].AccountTimeExpenseBillingId,
                    //     "InvoiceNo": tempInvoiceInformation[0].InvoiceNumber,
                    //     "InvoicePrefix": tempInvoiceInformation[0].InvoicePrefix,
                    //     "ClientName": tempInvoiceInformation[0].ClientName,
                    //     "AccountProjectId": tempInvoiceInformation[0].AccountProjectId,
                    //     "ProjectName": tempInvoiceInformation[0].ProjectName,
                    //     "BillingCycleEndDate": moment.parseZone(tempInvoiceInformation[0].BillingCycleEndDate).format('YYYY-MM-DD'), 
                    //     "BillingCycleStartDate": moment.parseZone(tempInvoiceInformation[0].BillingCycleStartDate).format('YYYY-MM-DD'),
                    // };
                    newMasterArray[0] = {
                        ...newMasterArray[0],
                        "AccountClientId": tempInvoiceInformation[0].AccountClientId,
                        "AccountCurrencyId": tempInvoiceInformation[0].AccountCurrencyId,
                        "AccountTimeExpenseBillingId": tempInvoiceInformation[0].AccountTimeExpenseBillingId,
                        "InvoiceNo": tempInvoiceInformation[0].InvoiceNumber,
                        "InvoicePrefix": tempInvoiceInformation[0].InvoicePrefix,
                        "ClientName": tempInvoiceInformation[0].ClientName,
                        "AccountProjectId": tempInvoiceInformation[0].AccountProjectId,
                        "ProjectName": tempInvoiceInformation[0].ProjectName,
                        "BillingCycleStartDate": tempInvoiceInformation[0].BillingCycleStartDate,
                        "BillingCycleEndDate": tempInvoiceInformation[0].BillingCycleEndDate,
                        "InvoiceDate": tempInvoiceInformation[0].InvoiceDate,
                        "InvoiceDueDate": tempInvoiceInformation[0].DueDate ,
                        "SubTotal": tempInvoiceInformation[0].SubTotal,
                        "TaxCode1": tempInvoiceInformation[0].TaxCode1,
                        "TaxCode2": tempInvoiceInformation[0].TaxCode2,
                        "GrandTotal": tempInvoiceInformation[0].GrandTotal,
                        "Discount": tempInvoiceInformation[0].Discount,
                        "DiscountPercentage": tempInvoiceInformation[0].DiscountPercentage
                        
 
                    };
                    state.masterAccountTimeExpenseBilling = [...newMasterArray];
                }
                if (action.payload.Data[1].length > 0) {
                    action.payload.Data[1].map((item: any) => {
                        item.IsSelected = false;
                        item.ProjectTaskArray = [{ "value": item.AccountProjectTaskId, "label": item.TaskName }];
                    });
                    state.timesheetBillingList = action.payload.Data[1];
                } else {
                    state.timesheetBillingList = [];
                }
                if (action.payload.Data[2].length > 0) {
                    action.payload.Data[2].map((item: any) => {
                        item.IsSelected = false;
                    });
                    state.expenseBillingList = action.payload.Data[2];
                } else {
                    state.expenseBillingList = [];
                }

              
                state.subTotal = tempInvoiceInformation[0].SubTotal;
                state.taxCode1 = tempInvoiceInformation[0].TaxCode1;
                state.taxCode2 = tempInvoiceInformation[0].TaxCode2;
                state.grandTotal = tempInvoiceInformation[0].GrandTotal;
                state.discount = tempInvoiceInformation[0].Discount;
                state.discountPercentage = tempInvoiceInformation[0].DiscountPercentage;
                state.dueDate = tempInvoiceInformation[0].DueDate;

                state.status = 'idle';
                state.isLoading = false;

            })
            .addCase(getInvoiceMasterandDetailRecordsList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getTimeExpenseBillingInvoice.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(getTimeExpenseBillingInvoice.fulfilled, (state, action) => {
                let subTotal = 0;
                let formulaAccountTaxCodeId1 = state.accountTaxCodeList.find(
                    x => x.value === (action.meta.arg.AccountTaxCodeId1 ?? 0)
                )?.Formula;
                let formulaAccountTaxCodeId2 = state.accountTaxCodeList.find(
                    x => x.value === (action.meta.arg.AccountTaxCodeId2 ?? 0)
                )?.Formula;
                if (action.payload.invoiceRecordsFor === -1 || action.payload.invoiceRecordsFor === 0) {
                    if (action.payload.json[0].length > 0) {
                        if (!action.payload.json[0][0].hasOwnProperty("Message")) {
                            action.payload.json[0].map((item: any) => {
                                item.AccountClientId = 0;
                                item.EmployeeName = "";
                                item.AccountTimeExpenseBillingTimesheetId = "";
                                item.ActualHours = item.TotalHours;
                                item.PartyName = "";
                                item.AccountTimeExpenseBillingId = "";
                                item.ExchangeRate = item.BillingRateExchangeRate;
                                item.AccountEmployeeId = null;
                                item.IsSelected = false;
                                item.IsEditable = false;
                                item.Description = item.Description === null ? `${item.ProjectName} (${item.TaskName})` : item.Description;
                                item.TotalAmount = item.TotalAmount === 0 ? (item.BillHours * item.BillingRate) : item.TotalAmount;
                                item.AccountTaxCodeId1 = action.meta.arg.AccountTaxCodeId1;
                                item.AccountTaxCodeId2 = action.meta.arg.AccountTaxCodeId2;
                                // Tax Calculation for TaxCode2 (if needed)
                                if (formulaAccountTaxCodeId1 && item.TotalAmount !== 0) {
                                    item.TaxCode1 = GetTaxValue(item.TotalAmount, formulaAccountTaxCodeId1);
                                }
                                // Tax Calculation for TaxCode2 (if needed)
                                if (formulaAccountTaxCodeId2 && item.TotalAmount !== 0) {
                                    item.TaxCode2 = GetTaxValue(item.TotalAmount, formulaAccountTaxCodeId2);
                                }

                                delete item.AccountId;
                                delete item.Billed;
                                delete item.TotalMinutes;
                                delete item.Amount;
                                delete item.TotalHours;
                                delete item.BillingRateExchangeRate;
                                delete item.IsBillable;
                                //subTotal = subTotal + item.TotalAmount;
                            });
                            state.timesheetBillingList = action.payload.json[0];
                        } else {
                            state.timesheetBillingList = [];
                        }
                    } else {
                        state.timesheetBillingList = [];
                    }
                }

                if (action.payload.invoiceRecordsFor === -1 || action.payload.invoiceRecordsFor === 1) {
                    if (action.payload.json[1].length > 0) {
                        if (!action.payload.json[1][0].hasOwnProperty("Message")) {
                            // state.expenseBillingList = action.payload.json[1]
                            action.payload.json[1].map((item: any) => {
                                let formulaAccountTaxCodeId1 = state.accountTaxCodeList.find(
                                    x => x.value === (action.meta.arg.AccountTaxCodeId1 ?? 0)
                                )?.Formula;
                                let formulaAccountTaxCodeId2 = state.accountTaxCodeList.find(
                                    x => x.value === (action.meta.arg.AccountTaxCodeId2 ?? 0)
                                )?.Formula;
                                item.BilledExpenseAmount = item.Amount / item.ExchangeRate * state.masterCurrencyExchangeRate
                                // item.BilledExpenseAmount = item.Amount;
                                item.ActualExpenseAmount = item.ActualExpenseAmount === null ? 0 : item.ActualExpenseAmount;
                                item.Description = item.Description === null ? `${item.ProjectName} (${item.AccountExpenseName})` : item.Description;
                                item.IsSelected = false;
                                item.IsEditable = false;
                                item.AccountTaxCodeId1 = action.meta.arg.AccountTaxCodeId1;
                                item.AccountTaxCodeId2 = action.meta.arg.AccountTaxCodeId2;
                                // Tax Calculation for TaxCode2 (if needed)
                                if (formulaAccountTaxCodeId1 && item.Amount !== 0) {
                                    item.TaxCode1 = GetTaxValue(item.Amount, formulaAccountTaxCodeId1);
                                }
                                // Tax Calculation for TaxCode2 (if needed)
                                if (formulaAccountTaxCodeId2 && item.Amount !== 0) {
                                    item.TaxCode2 = GetTaxValue(item.Amount, formulaAccountTaxCodeId2);
                                }
                                item.TaxName1 = item.TaxName1;
                                item.TaxName2 = item.TaxName2;
                                delete item.Amount;
                                delete item.Approved;
                                delete item.Billed;
                                //subTotal = subTotal + item.BilledExpenseAmount;
                            });
                            state.expenseBillingList = action.payload.json[1];
                        } else {
                            state.expenseBillingList = [];
                        }
                    } else {
                        state.expenseBillingList = [];
                    }
                }
               
                if (action.payload.invoiceRecordsFor === -1) {
                    state.masterAccountTimeExpenseBilling.map((item: any) => {
                        item.AccountTimeExpenseBillingId = "";
                    });
                }
                state.timesheetBillingList.length > 0 && state.timesheetBillingList.map((item) => {
                    subTotal = subTotal + item.TotalAmount;
                });
                state.expenseBillingList.length > 0 && state.expenseBillingList.map((item) => {
                    subTotal = subTotal + Number(item.BilledExpenseAmount);
                });



                let tax1 = 0;
                if (formulaAccountTaxCodeId1) {
                    // Replace 'Net' with the actual subTotal
                    let formulaWithValues = formulaAccountTaxCodeId1.replace(/Net/gi, subTotal);
                    try {
                        tax1 = eval(formulaWithValues); // Evaluate the formula
                    } catch (e) {
                        console.error("Error evaluating tax formula:", e);
                    }
                }

                let tax2 = 0;
                if (formulaAccountTaxCodeId2) {
                    // Replace 'Net' with the actual subTotal
                    let formulaWithValues = formulaAccountTaxCodeId2.replace(/Net/gi, subTotal);
                    try {
                        tax2 = eval(formulaWithValues); // Evaluate the formula
                    } catch (e) {
                        console.error("Error evaluating tax formula:", e);
                    }
                }

                // Helper function for calculating tax values
                function GetTaxValue(TotalAmount: any, Formula: string) {
                    if (Formula && typeof Formula === "string") {
                        if (Formula.includes("Net")) {
                            // Replace 'Net' in the formula with the actual TotalAmount
                            const formulaToBeParsed = Formula.replace(/Net/g, TotalAmount);
                            try {
                                // Use eval or Function to calculate the tax based on the formula
                                return new Function('return ' + formulaToBeParsed)();
                            } catch (e) {
                                console.error("Error in formula:", e);
                                return 0.00;
                            }
                        } else {
                            // If the formula is just a number
                            if (/^\d+(\.\d+)?$/.test(Formula)) {
                                return parseFloat(Formula);
                            } else {
                                return 0.00;
                            }
                        }
                    }
                    return 0.00;
                }

                let discountValue = Number(state.masterAccountTimeExpenseBilling[0].ShowDiscountCalculationBy) == 0 ? ((subTotal * state.discountPercentage) / 100) : Number(state.discountPercentage);
                state.subTotal = subTotal;
                state.discount = discountValue;
                state.taxCode1 = tax1;
                state.taxCode2 = tax2;
                state.grandTotal = subTotal + state.taxCode1 + state.taxCode2 - discountValue;
                state.masterAccountTimeExpenseBilling.map((item: any) => {
                    item.SubTotal = subTotal;
                    item.GrandTotal = subTotal - discountValue;
                    item.Discount = discountValue;
                    state.dueDate = item.InvoiceDueDate;
                });

                const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                newMasterArray[0] = {
                    ...newMasterArray[0],
                    SubTotal: state.subTotal,
                    GrandTotal: state.grandTotal,
                    TaxCode1: state.taxCode1,
                    TaxCode2: state.taxCode2,
                    Discount: state.discount
                };
                state.masterAccountTimeExpenseBilling = newMasterArray;

                state.status = 'idle';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getTimeExpenseBillingInvoice.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(updateAccountInvoice.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(updateAccountInvoice.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(updateAccountInvoice.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(SendToXero.pending, (state) => {
                state.status = 'loading';
                state.isListLoading = true;
                state.isReload = false;
            })
            .addCase(SendToXero.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isListLoading = false;
                //state.isReload = true;
                state.AccountTimeExpenseBillingIds = [];
                state.isAllChecked = false;
            })
            .addCase(SendToXero.rejected, (state) => {
                state.status = 'failed';
                state.isListLoading = false;
                state.isReload = false;
            })
            .addCase(deleteTimesheetBillingList.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(deleteTimesheetBillingList.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(deleteTimesheetBillingList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(deleteExpenseBillingList.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isReload = false;
            })
            .addCase(deleteExpenseBillingList.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(deleteExpenseBillingList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(deleteAccountInvoiceForm.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountInvoiceForm.fulfilled, (state, action) => {
                if (action.payload[0].Message == "Record(s) Removed Successfully!") {
                    if (action.payload.invoiceRecordsFor === 0) {
                        let timesheetTotal = 0;
                        let timesheetTaxCode1 = 0;
                        let timesheetTaxCode2 = 0;
                        state.timesheetBillingList.forEach(item => {
                            timesheetTotal = timesheetTotal + Number(item.TotalAmount);
                            timesheetTaxCode1 = timesheetTaxCode1 + item.TaxCode1;
                            timesheetTaxCode2 = timesheetTaxCode2 + item.TaxCode2;
                        });
                        state.timesheetBillingList = [];
                        const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                        newMasterArray[0] = {
                            ...newMasterArray[0],
                            "SubTotal": (state.subTotal - timesheetTotal),
                            "GrandTotal": (state.subTotal - state.taxCode1 - state.taxCode2)
                        };
                        state.masterAccountTimeExpenseBilling = newMasterArray;
                        state.subTotal = (state.subTotal - timesheetTotal);
                        state.grandTotal = (state.subTotal - state.taxCode1 - state.taxCode2);
                    } else if (action.payload.invoiceRecordsFor === 1) {
                        let expenseTotal = 0;
                        let tempTaxCode1 = 0;
                        let tempTaxCode2 = 0;
                        state.expenseBillingList.forEach(item => {
                            expenseTotal = expenseTotal + Number(item.BilledExpenseAmount);
                            tempTaxCode1 = tempTaxCode1 + item.TaxCode1;
                            tempTaxCode2 = tempTaxCode2 + item.TaxCode2;
                        });
                        state.expenseBillingList = [];
                        const newMasterArray = [...state.masterAccountTimeExpenseBilling];
                        newMasterArray[0] = {
                            ...newMasterArray[0],
                            "SubTotal": (state.subTotal - expenseTotal),
                            "GrandTotal": (state.subTotal - state.taxCode1 - state.taxCode2)
                        };
                        state.masterAccountTimeExpenseBilling = newMasterArray;
                        state.subTotal = (state.subTotal - expenseTotal);
                        state.grandTotal = (state.subTotal - state.taxCode1 - state.taxCode2);
                    } else if (action.payload.invoiceRecordsFor === -1) {
                        state.timesheetBillingList = [];
                        state.expenseBillingList = [];
                        // state.masterAccountTimeExpenseBilling = [{
                        //     "AccountClientContactId": 0,
                        //     "AccountClientId": 0,
                        //     "AccountCurrencyId": 0,
                        //     "AccountProjectId": 0,
                        //     "AccountTimeExpenseBillingId": "",
                        //     "BankDetails": "",
                        //     "Billable": -1,
                        //     "BillingCycleEndDate": '',
                        //     "BillingCycleStartDate": '',
                        //     "Description": "",
                        //     "Discount": 0,
                        //     "DiscountPercentage": 0,
                        //     "EmailTo": "",
                        //     "GrandTotal": 0,
                        //     "GroupExpenseBillingListBy": "",
                        //     "GroupTimesheetBillingListBy": "",
                        //     "InvoiceDate": "",
                        //     "InvoiceDueDate": "",
                        //     "InvoiceNo": 0,
                        //     "InvoicePrefix": "",
                        //     "IsBilled": false,
                        //     "IsEmailSend": 0,
                        //     "IsPaid": false,
                        //     "PONumber": "",
                        //     "ParentAccountProjectTaskId": 0,
                        //     "ShowDiscountCalculationBy": 0,
                        //     "SubTotal": 0,
                        //     'TaxCode1': 0,
                        //     "TaxCode2": 0,
                        //     "Terms": "",
                        //     "filterEmployees": "",
                        //     "AccountTaxCodeId1": 0,
                        //     "AccountTaxCodeId2": 0
                        // }];
                        // state.subTotal = 0;
                        // state.discount = 0;
                        // state.taxCode1 = 0;
                        // state.taxCode2 = 0;
                        // state.grandTotal = 0;
                        // state.dueDate = '';
                        // state.discountPercentage = 0;
                    }
                }
                state.status = 'idle';
            })
            .addCase(deleteAccountInvoiceForm.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(deleteAccountTimeExpenseBilling.pending, (state) => {
                state.status = 'loading';
                state.isListLoading = true;
                state.isReload = false;
            })
            .addCase(deleteAccountTimeExpenseBilling.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isListLoading = false;
                state.isReload = true;
            })
            .addCase(deleteAccountTimeExpenseBilling.rejected, (state) => {
                state.status = 'failed';
                state.isListLoading = false;
                state.isReload = false;
            })
            .addCase(getAccountInvoiceTemplateByClientId.pending, (state) => {
                state.status = 'loading';
                state.isReload = false;
            })
            .addCase(getAccountInvoiceTemplateByClientId.fulfilled, (state, action) => {
                state.status = 'idle';
                state.clientInvoiceFooter = action.payload.length > 0 ? action.payload[0].InvoiceFooter.split('\n').map((item: any) => item.trim()).filter((item: any) => item !== '') : "";
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getAccountInvoiceTemplateByClientId.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isReload = false;
            })
    }
})

export const { updateIsLoading, updateIsLoadingAndReload, updatePagination, updateSearchPagination, checkedState, unCheckedState,
    addItemTimesheetBillingList, removeItemInTimesheetBilling, updateAccountClientId, updateAccountProjectId, updateAccountProjectTaskId,
    isEditableTimesheetList, isCancelTimesheetList, addItemExpenseBillingList, removeItemInExpenseBilling, isEditableExpenseList, isCancelExpenseList,
    updateTimesheetBillingValues, updateExpenseBillingValues, updateDiscountValues, updateMasterTimeExpenseBilling, updateMasterTimeExpenseBillingValues,
    updateAccountTimeExpenseBillingId, updateMasterTimeExpenseBillingValuesByClient, updateAccountProjectTaskArray, updateProjectAndTaskInTimesheetList,
    updateProjectAndTaskInExpenseList, reCalculateInvoiceTotal, deleteItemInTimesheetBilling, deleteItemInExpenseBilling, removeProjectAndTaskInBothList,
    updateTimeExpenseBillingIdForPrint, updateIsListLoading, resetInvoiceFormLists, updateSorting, setAccountTimeExpenseBillingIdsState, setAllAccountTimeExpenseBillingIdsState,UpdateMasterCurrencyExchangeRate} = invoiceBillingSlice.actions
export const InvoiceBillingState = (state: RootState) => state.invoiceBilling
export default invoiceBillingSlice.reducer